import type { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { withBackgroundImage } from 'app/utils/style';
import { getCDNUrl } from 'app/utils/api_url';
import {
  getCsRoundNumber,
  getCsRoundScore
} from 'app/components/DesignVersion/Grad/Blocks/NameBlockGrad/utils';

import style from './style.module.scss';

interface Props {
  map: GameMap | undefined;
  team1: AggregatedTeamCsAny | undefined;
  team2: AggregatedTeamCsAny | undefined;
  // round_score — without it the banner is the map art alone.
  showScore: boolean;
}

// The current map, with the live round score over it. Reuses the shared
// map-image mixin so the art is darkened exactly like every other map header.
const CsMapBanner: FC<Props> = ({ map, team1, team2, showScore }) => {
  const { t } = useTranslation();
  const imageUrl = map?.image_url ? getCDNUrl(map.image_url) : undefined;

  return (
    <div
      className={classNames(style.banner, { [style.noImage]: !imageUrl })}
      style={imageUrl ? withBackgroundImage(imageUrl) : undefined}
    >
      {showScore && (
        <>
          <span className={style.score}>
            <span className={style.team1}>{getCsRoundScore(team1)}</span>
            <span className={style.separator}>:</span>
            <span className={style.team2}>{getCsRoundScore(team2)}</span>
          </span>
          <span className={style.round}>
            {t('block-grad-name-round', {
              defaultValue: 'Round {{round}}',
              round: getCsRoundNumber(team1, team2)
            })}
          </span>
        </>
      )}
    </div>
  );
};

CsMapBanner.displayName = 'CsMapBanner';

export default CsMapBanner;
